import { actionCreatorFactory } from "src/app/shared/utilities/state/Actions";
import {
  caseFn,
  reducerDefaultFn,
} from "src/app/shared/utilities/state/Reducers";
import {
  cartViewedEventLens,
  checkoutStartedEventLens,
  couponAppliedEventLens,
  orderCompletedEventLens,
  productAddedEventLens,
  productRemovedEventLens,
} from "./googleTagManager.lenses";
import {
  CartViewedEvent,
  CheckoutStartedEvent,
  CouponAppliedEvent,
  GoogleTagManagerState,
  OrderCompletedEvent,
  ProductAddedEvent,
  ProductRemovedEvent,
} from "./googleTagManager.models";
import { GTMEvents, gtmFeatureKey } from "./googleTagManager.consts";

const actionCreator = actionCreatorFactory(gtmFeatureKey);

export const productAddedEvent = actionCreator.simple<ProductAddedEvent>(
  GTMEvents.PRODUCT_ADDED
);
const productAddedEventReducer = caseFn(
  productAddedEvent,
  (s: GoogleTagManagerState, { value }) => productAddedEventLens.set(value)(s)
);

export const productRemovedEvent = actionCreator.simple<ProductRemovedEvent>(
  GTMEvents.PRODUCT_REMOVED
);
const productRemovedEventReducer = caseFn(
  productRemovedEvent,
  (s: GoogleTagManagerState, { value }) => productRemovedEventLens.set(value)(s)
);

export const cartViewedEvent = actionCreator.simple<CartViewedEvent>(
  GTMEvents.CART_VIEWED
);
const cartViewedEventReducer = caseFn(
  cartViewedEvent,
  (s: GoogleTagManagerState, { value }) => cartViewedEventLens.set(value)(s)
);

export const checkoutStartedEvent = actionCreator.simple<CheckoutStartedEvent>(
  GTMEvents.CHECKOUT_STARTED
);
const checkoutStartedEventReducer = caseFn(
  checkoutStartedEvent,
  (s: GoogleTagManagerState, { value }) =>
    checkoutStartedEventLens.set(value)(s)
);

export const orderCompletedEvent = actionCreator.simple<OrderCompletedEvent>(
  GTMEvents.ORDER_COMPLETED
);
const orderCompletedEventReducer = caseFn(
  orderCompletedEvent,
  (s: GoogleTagManagerState, { value }) => orderCompletedEventLens.set(value)(s)
);

export const couponAppliedEvent = actionCreator.simple<CouponAppliedEvent>(
  GTMEvents.COUPON_APPLIED
);
const couponAppliedEventReducer = caseFn(
  couponAppliedEvent,
  (s: GoogleTagManagerState, { value }) => couponAppliedEventLens.set(value)(s)
);

export const googleTagManagerReducer = reducerDefaultFn(
  {
    productAddedEvent: null,
    productRemovedEvent: null,
    cartViewedEvent: null,
    checkoutStartedEvent: null,
    orderCompletedEvent: null,
    couponAppliedEvent: null,
  } as GoogleTagManagerState,
  productAddedEventReducer,
  productRemovedEventReducer,
  cartViewedEventReducer,
  checkoutStartedEventReducer,
  orderCompletedEventReducer,
  couponAppliedEventReducer
);
